import Axios from "axios";
import React, { memo, useState } from "react";
import './questionnaire.css';

const QuestionsRetrievedInForm = memo(function QuestionsRetrievedInForm(props) {

    const [answer, setAnswer] = useState(null);
    const [answerElmsList, setAnswerElmsList] = useState([]);
    const [visitorIP, setVisitorIP] = useState("00.00.00.000");

    const [visibleForm, setVisibleForm] = useState(["inline"]);
    const [fireworks, setFireWorks] = useState('none');
    
    const getVisitorIP = () => {

        // Fetch the Visiot IP address from the API
        fetch("https://api.ipify.org?format=json")
        .then(response => response.json())
        .then(data => {
            setVisitorIP(data.ip)
        })
        .catch(error => {
            //console.error("Error fetching IP address:", error);
            setVisitorIP("00.00.00.000")
        });

    };
    

    if (!props.repos || props.repos.length === 0)
        return (
          <p style={{ color: "#fff", textAlign: "center" }}>
            API data loading now ...
          </p>
        );
    
    const id = props.repos.id;
    const theQuestion = props.repos.question;
    const type = props.repos.type;
    const options = props.repos.options;
    // we need to convert into JSON the data in table 'options'
    const optionsJsonFormat = JSON.parse(options);
    const numOptionsInJsonFormat = optionsJsonFormat.choices.length;
    let choices = [];
    for(let i = 0; i < numOptionsInJsonFormat;i++){
        choices.push(optionsJsonFormat['choices'][i]);
    }

    let selectedQuestion = [id,theQuestion,type,choices];

    // I run api to collect the VisitorIP
    getVisitorIP();

    const handleSelectionChange  = (e) => {
      if(type === 'checkbox'){
        getCheckboxValues();
      } else {
        setAnswer(e.target.value);
      }
    }

    function getCheckboxValues() {
      // Collect the checkbox selected and create a string with the selected values
      let checkboxes =
          document.getElementsByName('answer');
      let result = "";
      for (var i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].checked) {
              result += checkboxes[i].value + ",";
          }
      }
      setAnswer(result);
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const data = {
                id: id,
                question: theQuestion,
                answer: answer,
                visitorIP:visitorIP
            };
          
            // locally: http://localhost/richard_xampp/server/api/post_answers.php'

            const response = await Axios.post(
                'https://www.todaysminicrossword.com/server/api/post_answers.php',
                data
            );

            // Update the list after the answer is saved successfully.
            setAnswerElmsList([
                ...answerElmsList,
                {
                    id: response.data.id,
                    question: response.data.question,
                    answer: response.data.answer,
                    visitorIP:response.data.visitorIP,
                }
            ]);

            // Track only successful submissions.
            window.gtag?.("event", "feedback_submitted", {
                question_id: id,
                rating: answer,
            });

            setVisibleForm(['none', 'none']);
            setFireWorks('inline');

        } catch (error) {
            console.error("Error submitting feedback:", error);
        }
    };

    return (
      <React.Fragment>
    <div className="form-container" style={{border:`${visibleForm[1]}`}}> 
        <form style={{display:`${visibleForm[0]}`}} onSubmit={handleSubmit}>
        <div>{selectedQuestion[1]}</div>
        { choices.map((item,key) => (
                <div key={key}>
                <input
                type={selectedQuestion[2]}
                id={item}
                name="answer"
                value={item}
                onChange={handleSelectionChange}
              />
                <label htmlFor={item}>{item}</label> 
                </div>   
        ))}
        <div className="button-container" style={{margin:`${visibleForm[1]}`}}><button  className="btn" type="submit" disabled={!answer}>Ready?</button></div>
      </form>
    </div>
    <div className="thanks-answer" style={{display:`${fireworks}`}}><div>🎉</div></div>
    </React.Fragment>
  );
});

export default QuestionsRetrievedInForm;